import type { Campus, Child } from "../types";
import { getAuthHeaders } from "../utils/auth";

let cachedCampuses: Campus[] | null = null;

export const fetchChildrenByCampus = async (
  campusKey: string,
  preferCache: boolean = false
): Promise<Child[]> => {
  try {
    if (preferCache && cachedCampuses) {
      const campus = cachedCampuses.find(
        (campus) => campus.key == campusKey || campus.id == campusKey
      );
      if (campus && campus.children) {
        return campus.children;
      }
    }
    const headers = await getAuthHeaders();
    const response = await fetch(`/api/campuses/${campusKey}/children`, {
      headers,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const childrenData: Child[] = await response.json();
    return childrenData;
  } catch (error) {
    console.error("Error fetching children data:", error);
    throw error;
  }
};

export const fetchAllCampuses = async (
  preferCache: boolean = false
): Promise<Campus[]> => {
  try {
    if (preferCache && cachedCampuses) {
      return cachedCampuses;
    }
    const headers = await getAuthHeaders();
    const response = await fetch(`/api/campuses`, {
      headers,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const campusesData: Campus[] = await response.json();
    cachedCampuses = campusesData.map((campus) => ({
      id: Object.values(campus)[1].campusID,
      key: campus.id,
      name:
        campus.name ||
        `${campus.id.charAt(0).toUpperCase() + campus.id.slice(1)} Campus`,
      address: campus.address || `Address for ${campus.id}`,
      children: Object.values(campus).slice(1) || [],
      childrenCount: Object.keys(campus).length,
    }));
    return cachedCampuses;
  } catch (error) {
    console.error("Error fetching campuses data:", error);
    throw error;
  }
};

export const fetchCampusDetails = async (campusId: string): Promise<Campus> => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`/api/campuses/${campusId}`, {
      headers,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const campusData: Campus = await response.json();
    return campusData;
  } catch (error) {
    console.error("Error fetching campus details:", error);
    throw error;
  }
};
